/*!
 * oc-animations.js — Onisa Coté
 * Versión: 2.5.0 — 2026-05-21
 *
 * Lógica de arm() corregida:
 * - Elementos ya visibles en viewport → sin animación (se les da oc-visible inmediatamente)
 * - Elementos bajo el fold → IO los anima al hacer scroll
 * - Elementos encima del scroll → ignorados
 *
 * Esto evita que la comprobación de fold deje sin animar
 * elementos en viewports grandes (PC 1080p+).
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('oc-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0,
    rootMargin: '0px 0px -30px 0px'
  });

  /* ── arm(): solo anima elementos que están bajo el fold ──
     belowFold  → oc-anim-ready + IO → transición al hacer scroll
     inViewport → ya visible, no tocar: evita CLS por opacity:0 innecesario
     aboveFold  → ya scrollado, sin sentido animarlo */
  function arm(el, delayMs) {
    var rect = el.getBoundingClientRect();
    var belowFold = rect.top >= window.innerHeight;

    if (!belowFold) return; // visible o ya scrollado → sin animación, sin CLS

    if (delayMs) el.style.setProperty('--oc-delay', delayMs + 'ms');
    el.classList.add('oc-fade-up', 'oc-anim-ready');
    observer.observe(el);
  }

  /* ── ① Títulos de sección ── */
  function initSectionTitles() {
    ['.oc-edit__title', '.oc-bs__title', '.oc-rs__eyebrow', '.oc-rs__title']
      .forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) { arm(el, 0); });
      });
  }

  /* ── ② Pasos del ritual — stagger 120ms por paso ── */
  function initRitualSteps() {
    document.querySelectorAll('.oc-rs__step').forEach(function (el, i) {
      arm(el, i * 120);
    });
  }

  /* ── ③ Cards editorial — stagger 100ms por columna (ciclo de 3) ── */
  function initEditorialCards() {
    document.querySelectorAll('.oc-edit__card').forEach(function (el, i) {
      arm(el, (i % 3) * 100);
    });
  }

  function init() {
    initSectionTitles();
    initRitualSteps();
    initEditorialCards();
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }

})();
